/**
 * Constants for Positions Table in Payment Instruction Change
 */

// Column Names
export const COLUMN_NAMES = {
  POSITION: "Position",
  PAYMENT_BENEFICIARY: "Payment beneficiary",
  SCREENING: "Screening",
  UPDATED_RISK_RATING: "Updated risk rating",
  CURRENT_PAYMENT_INSTRUCTIONS: "Current payment instructions",
  PROGRAM: "Program",
};

// Field Names (with proper typing for ag-grid paths)
export const FIELD_NAMES = {
  POSITION: "investmentEntity.name" as const,
  PAYMENT_BENEFICIARY: "linkedProfile.legalName" as const,
  SCREENING: "screeningResult" as const,
  CURRENT_RISK_RATING: "currentRiskRating" as const,
  NEW_RISK_RATING: "newRiskRating" as const,
  CURRENT_BANK_NAME: "currentBankName" as const,
  REDACTED_BANK_ACCOUNT_NUMBER: "redactedBankAccountNumber" as const,
  PROGRAM: "program" as const,
};

// Tooltip content
export const TOOLTIP_TEXT = {
  SCREENING:
    "This is the result if this account profile is used as the owner of the updated payment instruction",
  RISK_RATING:
    "This is the risk rating of the position if this payment instruction is approved",
};
